export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t bg-white">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-3 px-4 py-6 text-sm text-slate-600 sm:flex-row">
        <p>© {year} Curățătoria Deniadi</p>
        <div className="flex items-center gap-4">
          <a href="tel:+40761686603" className="hover:text-slate-900">+40 761 686 603</a>
        </div>
      </div>
    </footer>
  );
}
